export enum TipoUsuario {
  TECSINAPSE = 'TECSINAPSE',
  MONTADORA = 'MONTADORA',
  DEALER_GRUPO = 'DEALER_GRUPO'
}

export const isDealer = (tipo: TipoUsuario | string) =>
  tipo === TipoUsuario.DEALER_GRUPO

export const isTecsinapse = (tipo: TipoUsuario | string) =>
  tipo === TipoUsuario.TECSINAPSE

export const isMontadora = (tipo: TipoUsuario | string) =>
  tipo === TipoUsuario.MONTADORA

export const containsDealer = (tipos?: (TipoUsuario | string)[]) =>
  (tipos ?? []).includes(TipoUsuario.DEALER_GRUPO)
